export const enum MEASUREMENT_TYPES {
  WEIGHT_KG = 1,
  WEIGHT_TON = 2,
  ENERGY_MJ_KG = 3,
  ENERGY_MJ_TON = 4,
  POWER_kWh_KG = 5,
  POWER_kWh_TON = 6,
  VOLUME_m3_PER_KG = 7,
  VOLUME_m3_PER_TON = 8,
  WEIGHT_GRAM = 9,
  TEMPERATURE_CELSIUS = 10,
  TEMPERATURE_KELVIN = 11
}
